import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import {
  Form,
  FormGroup,
  InputGroup,
  InputGroupText,
  Alert,
  Input,
  Label,
  Button,
} from "reactstrap";
import { serverHost } from "variables/serverdata.js";
import HusariaHeader from "views/pages/components/HusariaHeader";
import HusariaSelect from "components/HusariaSelect.js";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "./css/export-pdf.css";
/* ─── tiny helpers ─────────────────────────────────────────────── */
const fmt = (n) => `$${Number(n ?? 0).toFixed(2)}`;

function NewSubscription() {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const client_uuid = localStorage.getItem("clientId");
  const visibleColumns = [
    { key: "phone_number", label: "DID Number" },
    { key: "rate_center", label: "Rate Center" },
    { key: "site", label: "Site" },
    { key: "status", label: "Status" },
    { key: "intl_price", label: "Intl Cost" },
    { key: "description", label: "Description" },
  ];
  const rowKey = "phone_number";
  const navigate = useNavigate();
  const importRoute = "/admin/hucs/import-did";
  const [showHistory, setShowHistory] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [modules, setModules] = useState([
    {
      id: "35525bfe-5ee5-4ef7-8bd6-560d489803d5",
      name: "HUCS",
      total: 0,
      inUser: 0,
      licensePrice: 0,
      licenseTotal: 0,
      licenseDescription: "",
      isUnlimited: false,
      didsOwned: 0,
      didsPrice: 0,
      dids: {
        count: 0,
        rate_center: "Surrey",
        description: "",
        phone: "",
        site: "",
      },
      discounts: [],
      addOns: [],
      description: "Husaria Unified Communication System",
      icon: "hucs-icon.jpg",
    },
    {
      id: "be1c0fd0-81f7-401d-80fe-d264fcac2333",
      name: "HRMS",
      total: 0,
      inUser: 0,
      licensePrice: 0,
      licenseTotal: 0,
      licenseDescription: "",
      isUnlimited: false,
      discounts: [],
      addOns: [],
      description: "Human Resource Management System",
      icon: "hrms-icon.jpg",
    },
    {
      id: "899db0db-54eb-4918-8312-8c6559f68834",
      name: "HADM",
      total: 0,
      inUser: 0,
      licensePrice: 0,
      licenseTotal: 0,
      licenseDescription: "",
      isUnlimited: false,
      discounts: [],
      addOns: [],
      description: "Husaria Access Device Management",
      icon: "hadm-icon.jpg",
    },
    {
      id: "0c2f0b7c-34bd-420d-9edf-aaed115c1db1",
      name: "HANS",
      total: 0,
      inUser: 0,
      licensePrice: 0,
      licenseTotal: 0,
      licenseDescription: "",
      isUnlimited: false,
      discounts: [],
      addOns: [],
      description: "Husaria Access Notification System",
      icon: "hans-icon.jpg",
    },
  ]);
  const [hasIntl, setHasIntl] = useState(false);
  // "3_progress" | "2_renewal" | "past_due"
  const [subscriptionStatus, setSubscriptionStatus] =
    useState("bill_available");
  const [search, setSearch] = useState("");
  const [siteFilter, setSiteFilter] = useState("");

  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);
  const [showDID, setShowDID] = useState(false);
  const [saveStatus, setSaveStatus] = useState({
    show: false,
    success: false,
    message: "",
  });
  const [rateCenters, setRateCenters] = useState();
  const [blocks, setBlocks] = useState();
  const [nextTen, setNextTen] = useState();
  const [sites, setSites] = useState();
  const [clientDIDs, setClientDIDs] = useState([]);
  const [intlPrice, setIntlPrice] = useState(0);
  const [didsLoading, setDidsLoading] = useState(false);
  const clients = JSON.parse(localStorage.getItem("clientSites"));
  useEffect(() => {
    fetchModuleData();
    fetchRateCenters();
    fetchClientSites();
    fetchClientDIDs();
  }, []);

  useEffect(() => {
    const pending = sessionStorage.getItem("pendingDIDs");
    if (pending) {
      upd("35525bfe-5ee5-4ef7-8bd6-560d489803d5", {
        dids: JSON.parse(pending),
      });
    }
  }, []);

  useEffect(() => {
    return () => {
      const nextPath = window.location.pathname;
      if (!nextPath.includes("/import-did")) {
        sessionStorage.removeItem("pendingDIDs");
      }
    };
  }, []);

  const pagination = paginationFactory({
    page: 1,
    alwaysShowAllBtns: true,
    showTotal: true,
    withFirstAndLast: false,
    sizePerPageRenderer: ({ onSizePerPageChange }) => (
      <div className="dataTables_length">
        <label>
          Show{" "}
          <select
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>{" "}
          entries.
        </label>
      </div>
    ),
  });

  const columns = visibleColumns.map((col, index) => ({
    dataField: col.key,
    text: col.label,
    sort: true,
    formatter: (cell, row) => {
      if (col.key === "status") {
        const isActive = (cell ?? "active") === "active";
        return (
          <span
            style={{
              background: isActive ? "#10b98120" : "#f59e0b20",
              color: isActive ? "#10b981" : "#f59e0b",
              padding: "0.15rem 0.5rem",
              borderRadius: "4px",
              fontSize: "0.72rem",
              fontWeight: 700,
            }}
          >
            {cell ?? "active"}
          </span>
        );
      }

      const content = col.key === "intl_price" ? fmt(cell) : cell;

      return (
        <span style={{ padding: "0.55rem 0.85rem" }}>{content ?? "-"}</span>
      );
    },
    headerAlign: "center",
    align: "center",
  }));

  const filteredRows = React.useMemo(() => {
    if (!search && !siteFilter && !hasIntl) return clientDIDs;
    let filtered = clientDIDs;
    if (siteFilter) {
      filtered = filtered.filter((cdid) => cdid["site"] === siteFilter);
    }
    if (hasIntl) {
      {
        filtered = filtered.filter((cdid) => parseFloat(cdid.intl_price) > 0);
      }
    }
    if (search) {
      filtered = filtered.filter((cdid) =>
        visibleColumns.some((col) =>
          String(cdid[col.key] ?? "")
            .toLowerCase()
            .includes(search.toLowerCase()),
        ),
      );
    }
    return filtered;
  }, [clientDIDs, siteFilter, hasIntl, search]);

  /* ─── data fetching ────────────────────────────────────────────── */

  const fetchModuleData = async () => {
    try {
      const resp = await fetch(`${serverHost}/fetch_module_information`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ client_uuid }),
      });
      if (!resp.ok) {
        setLoading(false);
        return;
      }
      const sub_resp = await fetch(
        `${serverHost}/get_subscriptions/${client_uuid}`,
      );
      console.log(sub_resp);
      if (!sub_resp.ok) return;
      const subData = (await sub_resp.json()).data;
      console.log(subData);
      const moduleData = (await resp.json()).data;
      console.log(moduleData);

      setSubscriptionStatus(subData.status);
      setModules((prev) =>
        prev.map((module) => {
          const db = moduleData?.find((m) => m.name === module.name);
          console.log("Module name: ", module.name);
          return {
            ...module,
            total: subData[module.name]?.qty || 0,
            inUser: subData[module.name]?.in_user || 0,
            licensePrice: subData[module.name]?.price || 0,
            licenseTotal: subData[module.name]?.total || 0,
            licenseDescription: db?.description || "",
            isUnlimited: db?.limited || false,
            discounts: db?.discounts ? JSON.parse(db.discount_description) : [],
            addOns: db?.add_ons ? JSON.parse(db.addon_description) : [],
            ...(module.name === "HUCS" && {
              didsOwned: subData["DID"]?.qty || 0,
              didsPrice: subData["DID"]?.price || 0,
              licenseTotal:
                (subData[module.name]?.total || 0) +
                (subData["DID"]?.total || 0),
            }),
          };
        }),
      );
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const fetchRateCenters = async () => {
    try {
      const resp = await fetch(`${serverHost}/fetch_rate_centers`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!resp.ok) throw new Error("Failed to get the rate centers");
      const data = (await resp.json()).data;
      setRateCenters(data);
    } catch (err) {}
  };

  const fetchClientSites = async () => {
    try {
      const token =
        JSON.parse(localStorage.getItem("user") || "{}")?.access_token ||
        localStorage.getItem("token");
      const clientUuid = localStorage.getItem("clientId");
      const resp = await fetch(`${serverHost}/fetch_sites_detailed`, {
        method: "GET",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          client: clientUuid,
        },
      });
      if (!resp.ok) throw new Error("Failed to get the rate centers");
      const data = (await resp.json()).data;
      setSites(data);
    } catch (err) {
      console.log("Failed to get client sites - ", err);
    }
  };

  const fetchClientDIDs = async (forceRefresh = false) => {
    setDidsLoading(true);
    try {
      const token =
        JSON.parse(localStorage.getItem("user") || "{}")?.access_token ||
        localStorage.getItem("token");

      const url = forceRefresh
        ? `${serverHost}/fetch_client_dids?force=true`
        : `${serverHost}/fetch_client_dids`;

      const resp = await fetch(url, {
        method: "GET",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "Content-Type": "application/json",
          client: client_uuid,
        },
      });
      if (!resp.ok) throw new Error("Failed to fetch client DIDs");
      const did_data = await resp.json();
      const dids = did_data.data;
      const intl_cost = parseFloat(did_data.intl_price);
      console.log(intl_cost);
      setClientDIDs(dids ?? []);
      setIntlPrice(intl_cost);
    } catch (err) {
      console.error("Failed to fetch client DIDs -", err);
      setClientDIDs([]);
    } finally {
      setDidsLoading(false);
    }
  };

  /* ─── calculations ─────────────────────────────────────────────── */
  const calcFinal = (m) => {
    let base = m.licenseTotal;
    if (m.name === "HUCS") base += intlPrice;
    const disc = m.discounts.reduce((s, d) => {
      const q = m.isUnlimited ? d.quantity : Math.min(d.quantity, m.total);
      return s + q * d.value;
    }, 0);
    const add = m.addOns.reduce((s, a) => {
      const q = m.isUnlimited ? a.quantity : Math.min(a.quantity, m.total);
      return s + q * a.value;
    }, 0);
    return base - disc + add;
  };

  const subscriptionTotal = modules.reduce((s, m) => s + calcFinal(m), 0);
  const totalModules = modules.filter((m) => m.total > 0).length;

  /* ─── module state helpers ─────────────────────────────────────── */
  const upd = (id, patch) =>
    setModules((p) => p.map((m) => (m.id === id ? { ...m, ...patch } : m)));

  const addDiscount = (id) =>
    upd(id, {
      discounts: [
        ...modules.find((m) => m.id === id).discounts,
        { id: Date.now(), description: "", value: 0, quantity: 0 },
      ],
    });

  const removeDiscount = (mid, did) =>
    upd(mid, {
      discounts: modules
        .find((m) => m.id === mid)
        .discounts.filter((d) => d.id !== did),
    });

  const updateDiscount = (mid, did, field, val) =>
    upd(mid, {
      discounts: modules
        .find((m) => m.id === mid)
        .discounts.map((d) =>
          d.id === did
            ? {
                ...d,
                [field]:
                  field === "description"
                    ? val
                    : field === "quantity"
                      ? parseInt(val) || 0
                      : parseFloat(val) || 0,
              }
            : d,
        ),
    });

  const addAddOn = (id) =>
    upd(id, {
      addOns: [
        ...modules.find((m) => m.id === id).addOns,
        { id: Date.now(), description: "", value: 0, quantity: 0 },
      ],
    });

  const removeAddOn = (mid, aid) =>
    upd(mid, {
      addOns: modules
        .find((m) => m.id === mid)
        .addOns.filter((a) => a.id !== aid),
    });

  const updateAddOn = (mid, aid, field, val) =>
    upd(mid, {
      addOns: modules
        .find((m) => m.id === mid)
        .addOns.map((a) =>
          a.id === aid
            ? {
                ...a,
                [field]:
                  field === "description"
                    ? val
                    : field === "quantity"
                      ? parseInt(val) || 0
                      : parseFloat(val) || 0,
              }
            : a,
        ),
    });

  const didToggle = () => {
    if (showDID) {
      setModules((prev) =>
        prev.map((m) =>
          m.name === "HUCS"
            ? {
                ...m,
                dids: {
                  count: 0,
                  rate_center: "Surrey",
                  description: "",
                  phone: "",
                  site: "",
                },
              }
            : m,
        ),
      );
    }
    setShowDID((p) => !p);
  };

  const selectRateCenter = async (module, rc) => {
    upd(module.id, { dids: { ...module.dids, rate_center: rc } });
    try {
      const ten_resp = await fetch(`${serverHost}/fetch_ten/${encodeURI(rc)}`);
      if (!ten_resp.ok) throw new Error("Failed to get the next ten");
      const ten_data = (await ten_resp.json()).data;
      setNextTen(ten_data);

      const block_resp = await fetch(
        `${serverHost}/fetch_block/${encodeURI(rc)}`,
      );
      if (!block_resp.ok) throw new Error("Failed to get the block");
      const block_data = (await block_resp.json()).data;
      setBlocks(block_data);
    } catch (err) {}
  };

  /* ─── save ─────────────────────────────────────────────────────── */
  const handleSaveAll = async () => {
    try {
      const data = modules.map((m) => ({
        client_uuid,
        module_uuid: m.id,
        total_extensions: m.total,
        license_price: m.licensePrice,
        license_description: m.licenseDescription,
        is_unlimited: m.isUnlimited,
        discounts: JSON.stringify(m.discounts),
        addons: JSON.stringify(m.addOns),
      }));
      const resp = await fetch(`${serverHost}/add_license`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("user")).access_token}`,
          Insertions: "multiple",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const res = await resp.json();
      setSaveStatus({
        show: true,
        success: resp.ok,
        message: resp.ok ? "Saved successfully!" : "Error: " + res.error,
      });
    } catch (e) {
      setSaveStatus({
        show: true,
        success: false,
        message: "Error: " + e.message,
      });
    }
  };

  /* ─── PDF ──────────────────────────────────────────────────────── */
  const downloadInvoice = async () => {
    try {
      const resp = await fetch(`${serverHost}/get_invoice/${client_uuid}`, {
        method: "GET",
      });

      if (!resp.ok) {
        const err = await resp.json();
        throw new Error(err.error || "Failed to fetch invoice");
      }

      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice_${client_uuid}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download invoice:", err);
    }
  };

  const getChangeHistory = async () => {
    if (showHistory) {
      setShowHistory(false);
      return;
    }
    setShowHistory(true);
    setHistoryLoading(true);
    try {
      const resp = await fetch(`${serverHost}/get_history/${client_uuid}`, {
        method: "GET",
      });
      if (!resp.ok) throw new Error("Failed to fetch history");
      const data = (await resp.json()).data;
      setHistory(data ?? []);
    } catch (err) {
      console.error("Failed to fetch history -", err);
      setHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  /* ─── styles ───────────────────────────────────────────────────── */
  const card = isDark ? "#1e2737" : "#ffffff";
  const border = isDark ? "#2d3748" : "#e2e6ea";
  const text = isDark ? "#e2e8f0" : "#1a202c";
  const muted = isDark ? "#94a3b8" : "#64748b";
  const accent = "#3b82f6";
  const green = "#10b981";
  const readOnlyStyle = (isDark) => ({
    width: "100%",
    padding: "0.4rem 0.6rem",
    borderRadius: "6px",
    border: `1px solid ${isDark ? "#374151" : "#d1d5db"}`,
    background: isDark ? "#0f172a" : "#f1f5f9", // slightly muted vs. editable inputs
    color: isDark ? "#e2e8f0" : "#1a202c",
    fontSize: "0.82rem",
    boxSizing: "border-box",
    cursor: "default",
  });
  const statusMap = {
    active: { label: "Active", color: "#10b981", bg: "#10b98120" },
    bill_available: {
      label: "Bill Available",
      color: "#f59e0b",
      bg: "#f59e0b20",
    },
    past_due: { label: "Past Due", color: "#ef4444", bg: "#ef444420" },
  };
  const statusInfo = statusMap[subscriptionStatus] ?? statusMap.active;

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          color: muted,
        }}
      >
        Loading…
      </div>
    );

  return (
    <>
      <HusariaHeader name="Subscription" parentName="Admin" padding="3rem" />

      <div style={{ minHeight: "100vh", padding: "1.5rem 2rem" }}>
        {saveStatus.show && (
          <Alert
            color={saveStatus.success ? "success" : "danger"}
            isOpen={saveStatus.show}
            toggle={() => setSaveStatus((s) => ({ ...s, show: false }))}
            style={{ marginBottom: "1rem" }}
          >
            {saveStatus.message}
          </Alert>
        )}
        {/* ── subscription status ── */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            marginBottom: "1rem",
          }}
        >
          <span
            style={{
              fontSize: "0.78rem",
              fontWeight: 700,
              color: muted,
              textTransform: "uppercase",
              letterSpacing: "0.06em",
            }}
          >
            Subscription Status:
          </span>
          <span
            style={{
              fontSize: "0.82rem",
              fontWeight: 800,
              color: statusInfo.color,
              background: statusInfo.bg,
              padding: "0.15rem 0.6rem",
              borderRadius: "5px",
            }}
          >
            {statusInfo.label}
          </span>
        </div>
        {/* ── top summary bar ── */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-between",
            marginBottom: "1.5rem",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <div style={{ display: "flex", gap: "3rem" }}>
            <div>
              <div
                style={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  color: accent,
                  textTransform: "uppercase",
                  marginBottom: "0.2rem",
                }}
              >
                Subscription Total
              </div>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: 800,
                  color: text,
                  lineHeight: 1,
                }}
              >
                {fmt(subscriptionTotal)}
              </div>
            </div>
            <div>
              <div
                style={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  color: "#8b5cf6",
                  textTransform: "uppercase",
                  marginBottom: "0.2rem",
                }}
              >
                Active Modules
              </div>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: 800,
                  color: text,
                  lineHeight: 1,
                }}
              >
                {totalModules}
              </div>
            </div>
            <div>
              <div
                style={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  color: "#8b5cf6",
                  textTransform: "uppercase",
                  marginBottom: "0.2rem",
                }}
              >
                Total Sites
              </div>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: 800,
                  color: text,
                  lineHeight: 1,
                }}
              >
                {sites?.length ?? 0}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", gap: "0.5rem" }}>
            {/*<button onClick={handleSaveAll} style={btnStyle(accent)}>
              <i className="fas fa-save" style={{ marginRight: "0.4rem" }} />{" "}
              Save All
            </button>*/}
            <button
              onClick={getChangeHistory}
              className="export-btn"
              style={btnStyle(accent)}
            >
              <i className={!showHistory ? "fas fa-eye" : "fas fa-eye-slash"} style={{ marginRight: "0.2em" }} />{" "}
              {!showHistory ? "Show" : "Hide"} Changes
            </button>
            <button
              onClick={downloadInvoice}
              className="export-btn"
              style={btnStyle("#8b5cf6")}
            >
              <i
                className="fas fa-file-pdf"
                style={{ marginRight: "0.2rem" }}
              />{" "}
              Export PDF
            </button>
            <button
              onClick={() => {navigate("/admin/subscription/history")}}
              className="export-btn"
              style={btnStyle("#FFA12E")}
            >
              <i
                className="fas fa-history"
                style={{ marginRight: "0.2rem" }}
              />{" "}
              Previous Invoices
            </button>
          </div>
        </div>

        {/* ── module rows ── */}
        <div
          style={{ display: "flex", gap: "1.25rem", alignItems: "flex-start" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
              width: showHistory ? "75%" : "100%",
              transition: "width 0.25s ease",
            }}
          >
            {modules.map((module) => {
              const isOpen = expanded === module.id;
              return (
                <div
                  key={module.id}
                  style={{
                    background: card,
                    border: `1.5px solid ${isOpen ? accent : border}`,
                    borderRadius: "10px",
                    overflow: "hidden",
                    transition: "border-color 0.2s",
                  }}
                >
                  {/* ── collapsed row ── */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        module.name === "HUCS"
                          ? "1fr auto auto auto auto auto"
                          : "1fr auto auto auto auto",
                      alignItems: "center",
                      gap: "1.5rem",
                      padding: "1rem 1.25rem",
                      cursor: "pointer",
                    }}
                    onClick={() => setExpanded(isOpen ? null : module.id)}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: "0.75rem",
                          fontWeight: 700,
                          color: accent,
                          textTransform: "uppercase",
                          letterSpacing: "0.06em",
                        }}
                      >
                        {module.name}
                      </div>
                      <div
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: 800,
                          color: text,
                          lineHeight: 1.1,
                        }}
                      >
                        {fmt(calcFinal(module))}
                      </div>
                      <div
                        style={{
                          fontSize: "0.72rem",
                          color: muted,
                          marginTop: "0.15rem",
                        }}
                      >
                        {module.description}
                      </div>
                    </div>
                    {module.name === "HUCS" && (
                      <Pill
                        label="dids"
                        count={`${clientDIDs.length ?? 0}/${module.didsOwned || 0}`}
                        color="#ec4899"
                        isDark={isDark}
                      />
                    )}
                    <Pill
                      label="add ons"
                      count={module.addOns.length}
                      color="#3b82f6"
                      isDark={isDark}
                    />
                    <Pill
                      label="discounts"
                      count={module.discounts.length}
                      color="#f59e0b"
                      isDark={isDark}
                    />
                    <Pill
                      label="in use / total"
                      count={`${module.inUser}/${module.total}`}
                      color="#10b981"
                      isDark={isDark}
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(isOpen ? null : module.id);
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: green,
                        fontWeight: 700,
                        fontSize: "0.82rem",
                        whiteSpace: "nowrap",
                        padding: "0.25rem 0.5rem",
                      }}
                    >
                      {isOpen ? "▲ close" : "+ edit"}
                    </button>
                  </div>

                  {/* ── expanded detail panel ── */}
                  {isOpen && (
                    <div
                      style={{
                        borderTop: `1px solid ${border}`,
                        padding: "1.25rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                      }}
                    >
                      {/* top two-column grid: license + discounts/addons */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "1.5rem",
                        }}
                      >
                        {/* LEFT: basic fields */}
                        <div>
                          <SectionLabel>License</SectionLabel>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "0.5rem",
                            }}
                          >
                            <FieldLabel>
                              {module.name === "HUCS"
                                ? "Total Extensions"
                                : "Total Licenses"}
                            </FieldLabel>
                          </div>

                          {module.name === "HUCS" ? (
                            <>
                              <FieldLabel>
                                Total Extensions / Extension Price per Unit($)
                              </FieldLabel>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gap: "0.5rem",
                                }}
                              >
                                <div style={readOnlyStyle(isDark)}>
                                  {module.total}
                                </div>
                                <div style={readOnlyStyle(isDark)}>
                                  ${Number(module.licensePrice ?? 0).toFixed(2)}
                                </div>
                              </div>

                              <FieldLabel>
                                Total DIDs / DID Price per Unit ($)
                              </FieldLabel>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gap: "0.5rem",
                                }}
                              >
                                <div style={readOnlyStyle(isDark)}>
                                  {module.didsOwned}
                                </div>
                                <div style={readOnlyStyle(isDark)}>
                                  ${Number(module.didsPrice ?? 0).toFixed(2)}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <input
                                type="number"
                                value={module.total}
                                min={0}
                                onChange={(e) =>
                                  upd(module.id, {
                                    total: parseInt(e.target.value) || 0,
                                  })
                                }
                                style={inputStyle(isDark)}
                              />

                              <FieldLabel>License Price ($)</FieldLabel>
                              <input
                                type="number"
                                step="0.01"
                                value={module.licensePrice}
                                min={0}
                                onChange={(e) =>
                                  upd(module.id, {
                                    licensePrice:
                                      parseFloat(e.target.value) || 0,
                                  })
                                }
                                style={inputStyle(isDark)}
                              />
                            </>
                          )}

                          <FieldLabel>License Total ($)</FieldLabel>
                          <input
                            type="number"
                            step="0.01"
                            value={module.licenseTotal}
                            min={0}
                            onChange={(e) =>
                              upd(module.id, {
                                licenseTotal: parseFloat(e.target.value) || 0,
                              })
                            }
                            style={inputStyle(isDark)}
                          />

                          <FieldLabel>Description</FieldLabel>
                          <textarea
                            rows={3}
                            value={module.licenseDescription}
                            placeholder="Describe what this license covers…"
                            onChange={(e) =>
                              upd(module.id, {
                                licenseDescription: e.target.value,
                              })
                            }
                            style={{
                              ...inputStyle(isDark),
                              resize: "vertical",
                            }}
                          />

                          {/* DID add section for HUCS */}
                          {module.name === "HUCS" && (
                            <>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  margin: "1rem 0 0.5rem",
                                }}
                              >
                                <SectionLabel style={{ margin: 0 }}>
                                  DIDs
                                </SectionLabel>
                                <div style={{ display: "flex", gap: "5px" }}>
                                  <button
                                    style={btnStyle(
                                      !(clientDIDs.length >= module.didsOwned)
                                        ? "#5e72e4"
                                        : "#7F85A3",
                                      "sm",
                                    )}
                                    onClick={() => navigate(importRoute)}
                                    disabled={
                                      clientDIDs.length >= module.didsOwned
                                    }
                                  >
                                    <i className="fas fa-file-import"></i>{" "}
                                    Import DID
                                  </button>
                                  <button
                                    onClick={didToggle}
                                    style={btnStyle(
                                      showDID
                                        ? "#ef4444"
                                        : !(
                                              clientDIDs.length >=
                                              module.didsOwned
                                            )
                                          ? "#10B981"
                                          : "#709485",
                                      "sm",
                                    )}
                                    disabled={
                                      clientDIDs.length >= module.didsOwned
                                    }
                                  >
                                    {showDID ? (
                                      <i className="fas fa-trash" />
                                    ) : (
                                      <>
                                        <i className="fas fa-plus" /> Add
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                              {showDID && (
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr 1fr",
                                    gap: "0.5rem",
                                  }}
                                >
                                  <div>
                                    <FieldLabel>Rate Center</FieldLabel>
                                    <HusariaSelect
                                      name="rate_center"
                                      id="rate_center"
                                      options={rateCenters.map((rc) => ({
                                        value: rc.value,
                                        label: rc.label,
                                      }))}
                                      value={
                                        rateCenters.find(
                                          (rc) =>
                                            rc.value ===
                                            module.dids?.rate_center,
                                        ) || null
                                      }
                                      onChange={(option) =>
                                        selectRateCenter(module, option.value)
                                      }
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          borderRadius: "6px",
                                          border: `1px solid ${isDark ? "#374151" : "#d1d5db"}`,
                                          background: isDark
                                            ? "#111827"
                                            : "#fff",
                                          fontSize: "0.82rem",
                                          minHeight: "unset",
                                        }),
                                        singleValue: (base) => ({
                                          ...base,
                                          color: isDark ? "#e2e8f0" : "#1a202c",
                                          fontSize: "0.82rem",
                                        }),
                                        input: (base) => ({
                                          ...base,
                                          color: isDark ? "#e2e8f0" : "#1a202c",
                                          padding: "0.4rem 0.6rem",
                                          margin: 0,
                                          fontSize: "0.82rem",
                                        }),
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <FieldLabel>DID Type</FieldLabel>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "0.5rem",
                                        marginBottom: "0.4rem",
                                      }}
                                    >
                                      {["Single"].map((type) => (
                                        <button
                                          key={type}
                                          onClick={() =>
                                            upd(module.id, {
                                              dids: {
                                                ...module.dids,
                                                type,
                                                count:
                                                  type === "Single" ? 1 : "",
                                              },
                                            })
                                          }
                                          style={{
                                            padding: "0.25rem 0.75rem",
                                            borderRadius: "6px",
                                            border: `1px solid ${isDark ? "#374151" : "#d1d5db"}`,
                                            background:
                                              module.dids?.type === type
                                                ? "#4f8ef7"
                                                : "transparent",
                                            color:
                                              module.dids?.type === type
                                                ? "#fff"
                                                : isDark
                                                  ? "#e2e8f0"
                                                  : "#1a202c",
                                            fontSize: "0.82rem",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {type}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                  <div>
                                    <FieldLabel>Description</FieldLabel>
                                    <input
                                      type="text"
                                      value={module.dids?.description || ""}
                                      placeholder=""
                                      onChange={(e) =>
                                        upd(module.id, {
                                          dids: {
                                            ...module.dids,
                                            description: e.target.value,
                                          },
                                        })
                                      }
                                      style={inputStyle(isDark)}
                                    />
                                  </div>
                                </div>
                              )}
                            </>
                          )}

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "0.75fr 1fr 1fr",
                              gap: "0.5rem",
                            }}
                          >
                            {module.dids?.type === "Single" && (
                              <>
                                <div>
                                  <FieldLabel>Count</FieldLabel>
                                  <input
                                    type="number"
                                    value={1}
                                    disabled
                                    style={inputStyle(isDark)}
                                  />
                                </div>
                                <div>
                                  <FieldLabel>Site</FieldLabel>
                                  <select
                                    value={module.dids?.number || ""}
                                    onChange={(e) =>
                                      upd(module.id, {
                                        dids: {
                                          ...module.dids,
                                          site: e.target.value,
                                        },
                                      })
                                    }
                                    style={inputStyle(isDark)}
                                  >
                                    <option value="">Select ...</option>
                                    {sites?.map((s) => (
                                      <option
                                        key={s.company_name}
                                        value={JSON.stringify(s)}
                                      >
                                        {s.company_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </>
                            )}
                            {module.dids?.type === "Single" && (
                              <div>
                                <FieldLabel>Phone Number</FieldLabel>
                                <select
                                  value={module.dids?.phone || ""}
                                  onChange={(e) =>
                                    upd(module.id, {
                                      dids: {
                                        ...module.dids,
                                        phone: e.target.value,
                                      },
                                    })
                                  }
                                  style={inputStyle(isDark)}
                                >
                                  <option value="">Select ...</option>
                                  {nextTen?.map((nt) => (
                                    <option key={nt.Number} value={nt.Number}>
                                      {nt.Number}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </div>

                          <div
                            style={{ marginTop: "1rem", textAlign: "right" }}
                          >
                            <button
                              onClick={handleSaveAll}
                              style={btnStyle(green, "sm")}
                            >
                              <i
                                className="fas fa-save"
                                style={{ marginRight: "0.3rem" }}
                              />{" "}
                              Save Module
                            </button>
                          </div>
                        </div>
                        {/* RIGHT: discounts + add-ons */}
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "0.6rem",
                            }}
                          >
                            <SectionLabel>Discounts</SectionLabel>
                            <button
                              onClick={() => addDiscount(module.id)}
                              style={btnStyle("#f59e0b", "sm")}
                            >
                              <i className="fas fa-plus" /> Add
                            </button>
                          </div>
                          {module.discounts.length === 0 && (
                            <p
                              style={{
                                fontSize: "0.78rem",
                                color: muted,
                                marginBottom: "0.75rem",
                              }}
                            >
                              No discounts yet.
                            </p>
                          )}
                          {module.discounts.map((d, i) => (
                            <LineItem
                              key={d.id}
                              label={`Discount #${i + 1}`}
                              color="#f59e0b"
                              isDark={isDark}
                              item={d}
                              module={module}
                              onRemove={() => removeDiscount(module.id, d.id)}
                              onUpdate={(field, val) =>
                                updateDiscount(module.id, d.id, field, val)
                              }
                            />
                          ))}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              margin: "1rem 0 0.6rem",
                            }}
                          >
                            <SectionLabel>Add-Ons</SectionLabel>
                            <button
                              onClick={() => addAddOn(module.id)}
                              style={btnStyle(accent, "sm")}
                            >
                              <i className="fas fa-plus" /> Add
                            </button>
                          </div>
                          {module.addOns.length === 0 && (
                            <p style={{ fontSize: "0.78rem", color: muted }}>
                              No add-ons yet.
                            </p>
                          )}
                          {module.addOns.map((a, i) => (
                            <LineItem
                              key={a.id}
                              label={`Add-On #${i + 1}`}
                              color={accent}
                              isDark={isDark}
                              item={a}
                              module={module}
                              onRemove={() => removeAddOn(module.id, a.id)}
                              onUpdate={(field, val) =>
                                updateAddOn(module.id, a.id, field, val)
                              }
                            />
                          ))}
                        </div>
                      </div>

                      {/* ── Owned DIDs table (HUCS only) ── */}
                      {module.name === "HUCS" && (
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "0.75rem",
                            }}
                          >
                            <div>
                              <SectionLabel style={{ margin: 0 }}>
                                Owned DIDs
                              </SectionLabel>
                              <Input
                                type="select"
                                name="direction"
                                value={siteFilter}
                                onChange={(e) => setSiteFilter(e.target.value)}
                                style={{
                                  backgroundColor: isDark ? "#374151" : "#fff",
                                  color: isDark ? "#e2e8f0" : "#495057",
                                  borderColor: isDark ? "#4b5563" : "#ced4da",
                                  height: "40px",
                                  fontSize: "0.85rem",
                                }}
                              >
                                <option key={"all-sites"} value={""}>
                                  All
                                </option>
                                {clients.map((c, idx) => (
                                  <option key={idx} value={c.company_name}>
                                    {c.company_name}
                                  </option>
                                ))}
                              </Input>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                columnGap: "5px",
                                marginTop: "15px",
                              }}
                            >
                              <Form className="navbar-search navbar-search-light form-inline">
                                <FormGroup className="mb-0">
                                  <InputGroup className="input-group-alternative input-group-merge search-border">
                                    <InputGroupText>
                                      <i
                                        className="fas fa-search search-icon"
                                        style={{
                                          color: isDark
                                            ? "#b0b0b0"
                                            : "rgb(102, 102, 102)",
                                        }}
                                      />
                                    </InputGroupText>
                                    <Input
                                      className="form-control table-search-bar"
                                      placeholder="Search"
                                      value={search}
                                      onChange={(e) =>
                                        setSearch(e.target.value)
                                      }
                                    />
                                  </InputGroup>
                                </FormGroup>
                              </Form>
                              <button
                                style={btnStyle(
                                  hasIntl ? "#941616" : "#1E8547",
                                  "sm",
                                )}
                                onClick={() => setHasIntl((prev) => !prev)}
                              >
                                {hasIntl ? "Intl Cost only" : "All DIDs"}
                              </button>
                              <button
                                onClick={() => fetchClientDIDs(true)}
                                style={btnStyle("#64748b", "sm")}
                                disabled={didsLoading}
                              >
                                <i
                                  className={`fas fa-${didsLoading ? "spinner fa-spin" : "sync-alt"}`}
                                />{" "}
                                Refresh
                              </button>
                            </div>
                          </div>

                          {didsLoading ? (
                            <div
                              style={{
                                fontSize: "0.82rem",
                                color: muted,
                                padding: "1rem 0",
                              }}
                            >
                              Loading DIDs…
                            </div>
                          ) : clientDIDs.length === 0 ? (
                            <div
                              style={{
                                fontSize: "0.82rem",
                                color: muted,
                                padding: "0.75rem 1rem",
                                background: isDark ? "#0f172a" : "#f8fafc",
                                borderRadius: "8px",
                                border: `1px solid ${border}`,
                              }}
                            >
                              Client has no DIDs.
                            </div>
                          ) : (
                            <div
                              style={{
                                overflowX: "auto",
                                borderRadius: "8px",
                                border: `1px solid ${border}`,
                              }}
                            >
                              <ToolkitProvider
                                keyField={rowKey}
                                data={
                                  filteredRows ?? [
                                    {
                                      count: 0,
                                      rate_center: "",
                                      description: "",
                                      phone: "",
                                      site: "",
                                    },
                                  ]
                                }
                                columns={columns}
                              >
                                {(props) => (
                                  <div className="py-4 table-responsive">
                                    <BootstrapTable
                                      {...props.baseProps}
                                      bootstrap4
                                      pagination={pagination}
                                      bordered
                                      hover
                                      rowStyle={{
                                        cursor: "default",
                                        color: isDark ? "white" : "black",
                                      }}
                                      classes={`align-items-center table-flush ${isDark ? "table-dark" : ""}`}
                                      noDataIndication={() =>
                                        loading ? (
                                          <div className="text-center">
                                            Loading...
                                          </div>
                                        ) : (
                                          <div className="text-center">
                                            No DIDs found.
                                          </div>
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {showHistory && (
            <div
              style={{
                width: "25%",
                background: card,
                border: `1.5px solid ${border}`,
                borderRadius: "10px",
                padding: "1rem",
                maxHeight: "80vh",
                overflowY: "auto",
                position: "sticky",
                top: "1rem",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "0.75rem",
                }}
              >
                <SectionLabel style={{ margin: 0 }}>History</SectionLabel>
                <button
                  onClick={() => setShowHistory(false)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: muted,
                    fontSize: "0.9rem",
                  }}
                >
                  <i className="fas fa-times" />
                </button>
              </div>

              {historyLoading ? (
                <div style={{ fontSize: "0.8rem", color: muted }}>Loading…</div>
              ) : history.length === 0 ? (
                <div style={{ fontSize: "0.8rem", color: muted }}>
                  No history yet.
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.6rem",
                  }}
                >
                  {history.map((h, i) => (
                    <div
                      key={i}
                      style={{
                        fontSize: "0.75rem",
                        color: text,
                        borderBottom: `1px solid ${border}`,
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <div style={{ color: muted, fontSize: "0.68rem" }}>
                        {h.date}
                      </div>
                      <div>{h.message}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

/* ─── sub-components ───────────────────────────────────────────── */
function Pill({ label, count, color, isDark }) {
  return (
    <div style={{ textAlign: "center", minWidth: "70px" }}>
      <div
        style={{
          fontSize: "0.65rem",
          fontWeight: 600,
          color,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          marginBottom: "0.2rem",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "1.6rem",
          fontWeight: 800,
          color: isDark ? "#e2e8f0" : "#1a202c",
          lineHeight: 1,
        }}
      >
        {count}
      </div>
    </div>
  );
}

function SectionLabel({ children, style }) {
  return (
    <div
      style={{
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        marginBottom: "0.6rem",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

function FieldLabel({ children }) {
  return (
    <div
      style={{
        fontSize: "0.73rem",
        fontWeight: 600,
        color: "#94a3b8",
        marginBottom: "0.25rem",
        marginTop: "0.6rem",
      }}
    >
      {children}
    </div>
  );
}

function LineItem({ label, color, isDark, item, module, onRemove, onUpdate }) {
  return (
    <div
      style={{
        border: `1px solid ${isDark ? "#2d3748" : "#e2e6ea"}`,
        borderRadius: "7px",
        padding: "0.6rem 0.75rem",
        marginBottom: "0.5rem",
        background: isDark ? "#0f172a" : "#f8fafc",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "0.4rem",
        }}
      >
        <span style={{ fontSize: "0.72rem", fontWeight: 700, color }}>
          {label}
        </span>
        <button
          onClick={onRemove}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#ef4444",
            fontSize: "0.8rem",
          }}
        >
          <i className="fas fa-trash" />
        </button>
      </div>
      <input
        type="text"
        placeholder="Description"
        value={item.description}
        onChange={(e) => onUpdate("description", e.target.value)}
        style={{ ...inputStyle(isDark), marginBottom: "0.4rem" }}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0.5rem",
        }}
      >
        <input
          type="number"
          step="0.01"
          placeholder="Value ($)"
          value={item.value}
          onChange={(e) => onUpdate("value", e.target.value)}
          style={inputStyle(isDark)}
        />
        <input
          type="number"
          placeholder="Qty"
          value={item.quantity}
          max={module.isUnlimited ? undefined : module.total}
          onChange={(e) => onUpdate("quantity", e.target.value)}
          style={inputStyle(isDark)}
        />
      </div>
    </div>
  );
}

/* ─── style helpers ────────────────────────────────────────────── */
const btnStyle = (color, size) => ({
  background: color,
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: size === "sm" ? "0.3rem 0.65rem" : "0.5rem 1rem",
  fontSize: size === "sm" ? "0.75rem" : "0.85rem",
  fontWeight: 700,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: "0.3rem",
});

const inputStyle = (isDark) => ({
  width: "100%",
  padding: "0.4rem 0.6rem",
  borderRadius: "6px",
  border: `1px solid ${isDark ? "#374151" : "#d1d5db"}`,
  background: isDark ? "#111827" : "#fff",
  color: isDark ? "#e2e8f0" : "#1a202c",
  fontSize: "0.82rem",
  outline: "none",
  boxSizing: "border-box",
});

export default NewSubscription;
